var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',_vm._g(_vm._b({class:[
    _vm.model ? 'checked' : '',
    'custom-checkbox',
    _vm.error == true ? 'is-error' : ''
  ],attrs:{"true-label":1,"false-label":0,"disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'el-checkbox',_vm.$attrs,false),{ ..._vm.$listeners, change: () => {} }),[_vm._v(_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }